import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left: Quote */}
          <div className="w-full lg:w-3/5">
            <div className="flex items-center gap-2 mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-foreground-400"></span>
              <span className="text-xs font-label font-medium text-foreground-400 uppercase tracking-wider">{t('trust.label')}</span>
            </div>
            <blockquote className="font-heading text-2xl md:text-4xl font-medium text-foreground-900 leading-relaxed italic mb-6">
              <span className="text-primary-500 text-4xl md:text-5xl leading-none">&ldquo;</span>
              {t('trust.quote')}
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="font-heading text-base font-semibold text-foreground-800">{t('trust.author')}</span>
              <span className="flex items-center gap-1.5 text-xs text-accent-600 font-label">
                <i className="ri-verified-badge-fill w-4 h-4 flex items-center justify-center"></i>
                {t('trust.verified')}
              </span>
            </div>
          </div>

          {/* Right: Image */}
          <div className="hidden lg:block w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20lifestyle%20portrait%20of%20a%20stylish%20Italian%20man%20in%20casual%20linen%20shirt%20against%20a%20sunlit%20Mediterranean%20balcony%20with%20warm%20terracotta%20tones%20and%20soft%20ocean%20blur%20background%2C%20natural%20golden%20hour%20lighting%2C%20authentic%20editorial%20fashion%20photography%20with%20relaxed%20confident%20expression%2C%20warm%20earthy%20Mediterranean%20color%20palette&width=600&height=800&seq=trust-portrait-itaobuy-v2-2026&orientation=portrait"
                alt="Recensione Itaobuy Spreadsheet"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}